import { jsonFetch } from "@/lib/helpers";
import { Environment } from "@/models";
import { GET_ENVIRONMENT_BETWEEN_RANGE_BY_ROOM_ID } from "./api-url.constants";
import { GetEnvironmentBetweenRangeByMonitorIdResponseApiDto } from "./dtos";
import { mapperEnvironmentsDTOToMonitors } from "./mappers";

interface GetEnvironmentBetweenRangeByRoomIdParams {
  roomId: string;
  from: number;
  to: number;
  monitorId?: string;
}

export const getEnvironmentBetweenRangeByRoomId = async ({
  roomId,
  from,
  to,
  monitorId,
}: GetEnvironmentBetweenRangeByRoomIdParams): Promise<Environment[]> => {
  let url = `${GET_ENVIRONMENT_BETWEEN_RANGE_BY_ROOM_ID}/${encodeURIComponent(roomId)}?from=${from}&to=${to}`;
  if (monitorId) url += `&monitorId=${encodeURIComponent(monitorId)}`;
  const environmentsDTO = await jsonFetch<GetEnvironmentBetweenRangeByMonitorIdResponseApiDto>(url);
  return mapperEnvironmentsDTOToMonitors(environmentsDTO);
};
